export const SESSION_EXPIRED_MESSAGE =
  'Время сеанса истекло. Войдите снова для обновления токена.';

export const SESSION_EXPIRED_STORAGE_KEY = 'session_expired_message';

const AUTH_SKIP_PATHS = ['/auth/login', '/health'];

let sessionExpiredHandled = false;
let onSessionExpiredHandler = null;

export function registerSessionExpiredHandler(handler) {
  onSessionExpiredHandler = handler;
}

export function resetSessionExpiredGuard() {
  sessionExpiredHandled = false;
}

export function decodeJwtPayload(token) {
  try {
    const base64Url = token.split('.')[1];
    if (!base64Url) return null;
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const binaryStr = atob(base64);
    const bytes = new Uint8Array(binaryStr.length);
    for (let i = 0; i < binaryStr.length; i++) {
      bytes[i] = binaryStr.charCodeAt(i);
    }
    return JSON.parse(new TextDecoder('utf-8').decode(bytes));
  } catch {
    return null;
  }
}

export function isJwtExpired(token, leewaySec = 30) {
  if (!token) return true;
  const payload = decodeJwtPayload(token);
  if (!payload?.exp) return false;
  return Date.now() >= payload.exp * 1000 - leewaySec * 1000;
}

function getResponseErrorMessage(error) {
  const data = error?.response?.data;
  if (typeof data === 'string') return data;
  return data?.error || data?.message || '';
}

export function isSessionAuthError(error) {
  const status = error?.response?.status;
  const message = getResponseErrorMessage(error).toLowerCase();
  const url = String(error?.config?.url || '');

  if (status === 401) return true;

  if (status === 404 && url.includes('/auth/verify')) return true;

  if (status === 403) {
    if (
      message.includes('недействительный токен')
      || message.includes('токен не предоставлен')
      || message.includes('токен авторизации не предоставлен')
      || message.includes('пользователь заблокирован')
    ) {
      return true;
    }
    if (message.includes('token') && (message.includes('invalid') || message.includes('expired'))) {
      return true;
    }
  }

  return false;
}

export function shouldSkipSessionCheck(url = '') {
  return AUTH_SKIP_PATHS.some((path) => String(url).includes(path));
}

export function consumeSessionExpiredMessage() {
  const message = sessionStorage.getItem(SESSION_EXPIRED_STORAGE_KEY);
  if (message) {
    sessionStorage.removeItem(SESSION_EXPIRED_STORAGE_KEY);
  }
  return message;
}

export function triggerSessionExpired(message = SESSION_EXPIRED_MESSAGE) {
  if (sessionExpiredHandled) return;
  sessionExpiredHandled = true;

  sessionStorage.setItem(SESSION_EXPIRED_STORAGE_KEY, message);

  if (onSessionExpiredHandler) {
    onSessionExpiredHandler(message);
    return;
  }

  localStorage.removeItem('token');
  if (window.location.pathname !== '/login') {
    window.location.replace('/login');
  }
}

export function ensureValidSession(message = SESSION_EXPIRED_MESSAGE) {
  const token = localStorage.getItem('token');
  if (!token || isJwtExpired(token)) {
    triggerSessionExpired(message);
    return false;
  }
  return true;
}
